import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dispo-employment-list-item-skeleton',
  templateUrl: './dispo-employment-list-item-skeleton.component.html',
  styleUrls: ['./dispo-employment-list-item-skeleton.component.scss'],
})
export class DispoEmploymentListItemSkeletonComponent {
  @Input() showSkeleton = true;
}
